/* NGlow Global JS (Clean Version) */
window.NGlow = window.NGlow || {};

/**
 * Money Formatting Utility
 */
window.NGlow.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return '0';
        const fixedNumber = (number / 100.0).toFixed(precision);
        var parts = fixedNumber.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            centsStr = parts[1] ? (decimal + parts[1]) : '';
        return dollars + centsStr;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    let value = '';
    switch (match[1]) {
        case 'amount': value = formatWithDelimiters(Number(cents), 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(Number(cents), 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(Number(cents), 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(Number(cents), 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
};

/**
 * Main Initialization
 */
document.addEventListener('NGlow:Ready', () => {
    console.log("NGlow Engine Initialized");

    // Initialize the protected Menu Logic
    if (window.NGlow_InitMenu) window.NGlow_InitMenu();

    // Navbar Scroll Effect
    window.addEventListener('scroll', () => {
        const nav = document.querySelector('.integrated-nav');
        if (!nav) return;
        nav.classList.toggle('scrolled', window.scrollY > 150);
    });

    // Mobile Search Overlay
    const searchTrigger = document.querySelector('.mobile-search-trigger');
    const searchOverlay = document.getElementById('search-overlay');
    if (searchTrigger && searchOverlay) {
        searchTrigger.addEventListener('click', () => {
            searchOverlay.classList.add('active');
            const input = document.getElementById('search-input');
            if (input) setTimeout(() => input.focus(), 300);
        });
    }
});